<div class="toggle-header">
    <button class="toggle-btn" [class.active]="viewMode === 'map'" (click)="viewMode = 'map'">
        <i class="fa fa-map-marker"></i> {{'ADDRESS.VIEW.MAP' | translate}}
    </button>
    <button class="toggle-btn" [class.active]="viewMode === 'fields'" (click)="viewMode = 'fields'">
        <i class="fa fa-align-left"></i> {{'ADDRESS.VIEW.FIELDS' | translate}}
    </button>
</div>

<ng-container *ngIf="viewMode === 'map'">
    <div class="copy-bar" *ngIf="addressData?.formattedAddress">
        <span class="copy-text">{{addressData.formattedAddress}}</span>
        <button class="copy-btn" (click)="copyToClipboard()" title="{{'ADDRESS.COPY' | translate}}">
            <i class="fa fa-copy"></i>
        </button>
    </div>
    <div class="mapa-wrapper">
        <shared-map class="mapa" [forcedZoom]="zoom" [latitude]="latitude" [longitude]="longitude" [marcadors]="marcadors">
        </shared-map>
    </div>
</ng-container>

<ng-container *ngIf="viewMode === 'fields'">
    <div class="fields-view">

        <div class="af">
            <span class="af-label" *ngIf="addressData?.addressLine1">{{'ADDRESS.ADDRESSLINE1.CAPTION' | translate}}</span>
            <shared-copyclipboard [value]="addressData?.addressLine1 ?? ''">
                <span class="af-value" [class.af-placeholder]="!addressData?.addressLine1">
                    {{addressData?.addressLine1 || ('ADDRESS.ADDRESSLINE1.CAPTION' | translate)}}
                </span>
            </shared-copyclipboard>
        </div>

        <div class="af">
            <span class="af-label" *ngIf="addressData?.addressLine2">{{'ADDRESS.ADDRESSLINE2.CAPTION' | translate}}</span>
            <shared-copyclipboard [value]="addressData?.addressLine2 ?? ''">
                <span class="af-value" [class.af-placeholder]="!addressData?.addressLine2">
                    {{addressData?.addressLine2 || ('ADDRESS.ADDRESSLINE2.CAPTION' | translate)}}
                </span>
            </shared-copyclipboard>
        </div>

        <div class="af-row">
            <div class="af af-cp">
                <span class="af-label" *ngIf="addressData?.postalCode">{{'ADDRESS.POSTALCODE.CAPTION' | translate}}</span>
                <shared-copyclipboard [value]="addressData?.postalCode ?? ''">
                    <span class="af-value" [class.af-placeholder]="!addressData?.postalCode" [class.af-critical]="!addressData?.postalCode">
                        {{addressData?.postalCode || ('ADDRESS.POSTALCODE.CAPTION' | translate)}}
                    </span>
                </shared-copyclipboard>
            </div>
            <div class="af af-city">
                <span class="af-label" *ngIf="addressData?.city">{{'ADDRESS.CITY.CAPTION' | translate}}</span>
                <shared-copyclipboard [value]="addressData?.city ?? ''">
                    <span class="af-value" [class.af-placeholder]="!addressData?.city">
                        {{addressData?.city || ('ADDRESS.CITY.CAPTION' | translate)}}
                    </span>
                </shared-copyclipboard>
            </div>
        </div>

        <div class="af">
            <span class="af-label" *ngIf="addressData?.province">{{'ADDRESS.PROVINCE.CAPTION' | translate}}</span>
            <shared-copyclipboard [value]="addressData?.province ?? ''">
                <span class="af-value" [class.af-placeholder]="!addressData?.province">
                    {{addressData?.province || ('ADDRESS.PROVINCE.CAPTION' | translate)}}
                </span>
            </shared-copyclipboard>
        </div>

        <div class="af">
            <span class="af-label" *ngIf="addressData?.state">{{'ADDRESS.STATE.CAPTION' | translate}}</span>
            <shared-copyclipboard [value]="addressData?.state ?? ''">
                <span class="af-value" [class.af-placeholder]="!addressData?.state">
                    {{addressData?.state || ('ADDRESS.STATE.CAPTION' | translate)}}
                </span>
            </shared-copyclipboard>
        </div>

        <div class="af">
            <span class="af-label" *ngIf="addressData?.country">{{'ADDRESS.COUNTRY.CAPTION' | translate}}</span>
            <shared-copyclipboard [value]="addressData?.country ?? ''">
                <span class="af-value" [class.af-placeholder]="!addressData?.country">
                    {{addressData?.country || ('ADDRESS.COUNTRY.CAPTION' | translate)}}
                </span>
            </shared-copyclipboard>
        </div>

        <div class="af">
            <span class="af-label" *ngIf="coordinatesText">{{'ADDRESS.COORDINATES.CAPTION' | translate}}</span>
            <shared-copyclipboard [value]="coordinatesText">
                <span class="af-value" [class.af-placeholder]="!coordinatesText">
                    {{coordinatesText || ('ADDRESS.COORDINATES.CAPTION' | translate)}}
                </span>
            </shared-copyclipboard>
        </div>

        <div class="af af-formatted">
            <span class="af-label" *ngIf="addressData?.formattedAddress">{{'ADDRESS.FORMATEDADDRESS.CAPTION' | translate}}</span>
            <shared-copyclipboard [value]="addressData?.formattedAddress ?? ''">
                <span class="af-value" [class.af-placeholder]="!addressData?.formattedAddress">
                    {{addressData?.formattedAddress || ('ADDRESS.FORMATEDADDRESS.CAPTION' | translate)}}
                </span>
            </shared-copyclipboard>
        </div>

    </div>
</ng-container>
